export default {
  "Désignation": "Description",
  "Qté": "Qty",
  "PU HT (€)": "Unit price excl. tax (€)",
  "TVA %": "VAT %",
  "Total HT": "Total excl. tax",
  "Désignation ligne {0}": "Line {0} description",
  "Quantité ligne {0}": "Line {0} quantity",
  "Prix unitaire ligne {0}": "Line {0} unit price",
  "TVA ligne {0}": "Line {0} VAT",
  "Supprimer la ligne {0}": "Delete line {0}",
  "Ajouter une ligne": "Add a line",
  "Finaliser et numéroter": "Finalise and number",
  "Finaliser": "Finalise",
  "Marquer comme envoyé": "Mark as sent",
  "Marquer payée": "Mark as paid",
  "Retour aux documents": "Back to documents",
  "Généré avec l'IA · à relire": "AI-generated · to review",
  "Enregistrement…": "Saving…",
  "Modifications en cours…": "Unsaved changes…",
  "Échec de l'enregistrement": "Save failed",
  "Enregistré · v{0}": "Saved · v{0}",
  "Convertir en facture": "Convert to invoice",
  "Plus d'actions": "More actions",
  "Exporter en DOCX": "Export to DOCX",
  "Lien de partage (7 jours) copié.": "Share link (7 days) copied.",
  "Copier un lien de partage (7 j)": "Copy a share link (7 d)",
  "Ouvrir dans Gmail": "Open in Gmail",
  "Ouvrir dans ma messagerie": "Open in my email app",
  "Dupliquer": "Duplicate",
  "Versions (": "Versions (",
  "Annuler ce document ?": "Cancel this document?",
  "Annuler le document": "Cancel document",
  "Supprimer définitivement ce document ?": "Permanently delete this document?",
  "Facture émise : son contenu est figé. Pour corriger, annulez-la et émettez-en une nouvelle.": "Issued invoice: its content is locked. To correct it, cancel it and issue a new one.",
  "Titre du document": "Document title",
  "Valable jusqu'au": "Valid until",
  "TVA non applicable, art. 293 B du CGI": "VAT not applicable, art. 293 B of the French Tax Code",
  "Notes / conditions (affichées sur le document)": "Notes / terms (shown on the document)",
  "Complétez vos informations d'entreprise (raison sociale, adresse, SIRET, TVA) dans": "Complete your business details (company name, address, company number, VAT) in",
  "Paramètres › Entreprise": "Settings › Business",
  ": elles figurent sur vos devis et factures.": ": they appear on your quotes and invoices.",
  "Rédaction": "Writing",
  "Aperçu": "Preview",
  "Contenu du document (Markdown)": "Document content (Markdown)",
  "Rédigez en Markdown : ## Titre, - liste, **gras**…": "Write in Markdown: ## Heading, - list, **bold**…",
  "*Document vide.*": "*Empty document.*",
  "Contrôle qualité": "Quality check",
  "Champs manquants, dates, montants, mentions. Ne garantit pas la conformité juridique.": "Missing fields, dates, amounts, legal notices. Does not guarantee legal compliance.",
  "Vérifier": "Check",
  "+ relecture IA": "+ AI review",
  "Aucun problème détecté.": "No issues found.",
  "Document intelligent": "Smart document",
  "Résumer": "Summarise",
  "Clauses à vérifier": "Clauses to check",
  "Obligations & échéances": "Obligations & deadlines",
  "Points à négocier": "Points to negotiate",
  "Prépare un message de relance à relire. Rien n'est envoyé automatiquement.": "Prepares a follow-up message to review. Nothing is sent automatically.",
  "· modifié": "· edited",
  "Client :": "Customer:",
  "Analyse du document": "Document analysis",
  "Brouillon de relance": "Follow-up draft",
  "Relisez et adaptez avant envoi depuis votre messagerie.": "Review and adapt before sending from your email app.",
  "Relance": "Follow-up",
  "Historique des versions": "Version history",
  "Aucune version antérieure.": "No earlier versions.",
  "Version restaurée.": "Version restored.",
  "Restaurer": "Restore",
  "Démarrer": "Getting started",
  "Après l'inscription, l'onboarding configure votre profil, vos objectifs et vos horaires, puis le Coach IA prépare un premier plan d'action. Tout reste modifiable dans Paramètres.": "After signing up, onboarding sets up your profile, goals and working hours, then the AI Coach prepares a first action plan. Everything can be changed in Settings.",
  "Le Coach IA": "The AI Coach",
  "Choisissez un mode (Business, Productivité, Finance, Marketing, Rédaction, Projet). Les réponses s'affichent en temps réel ; vous pouvez arrêter, copier ou régénérer une réponse, et rechercher, renommer, archiver ou supprimer vos conversations. Raccourci : Ctrl/⌘ K pour tout retrouver.": "Choose a mode (Business, Productivity, Finance, Marketing, Writing, Project). Answers appear in real time; you can stop, copy or regenerate an answer, and search, rename, archive or delete your conversations. Shortcut: Ctrl/⌘ K to find anything.",
  "Vos données sont isolées par compte. Pour générer une réponse, le serveur transmet au fournisseur d'IA configuré (par défaut DeepSeek) votre message, l'historique récent de la conversation, votre profil déclaré et votre mémoire active — rien d'autre. Selon le fournisseur, ce traitement peut avoir lieu hors de l'Union européenne. Vous pouvez exporter ou supprimer vos données et votre compte à tout moment (Paramètres › Confidentialité).": "Your data is isolated per account. To generate an answer, the server sends the configured AI provider (DeepSeek by default) your message, the recent conversation history, your stated profile and your active memory — nothing else. Depending on the provider, this processing may take place outside the European Union. You can export or delete your data and account at any time (Settings › Privacy).",
  "Les contenus produits par l'IA sont une aide à la décision : ils ne constituent ni un conseil juridique, ni un conseil fiscal ou comptable.": "AI-generated content is a decision aid: it is not legal, tax or accounting advice.",
  "Contact et assistance": "Contact and support",
  "GBC Coach IA est une application éditée par NeoTechRams.": "GBC Coach IA is an app published by NeoTechRams.",
  "Écrivez-nous :": "Write to us:",
  "Depuis l'application, le Coach peut aussi répondre à vos questions sur son fonctionnement.": "In the app, the Coach can also answer your questions about how it works.",
  "Conditions d'utilisation": "Terms of use",
  "Supprimer mon compte": "Delete my account",
  "Vous": "You",
  "Vos objectifs": "Your goals",
  "C'est parti": "Let's go",
  "Étape {0} sur {1}": "Step {0} of {1}",
  "Bienvenue": "Welcome",
  "Trois questions rapides pour adapter votre Copilote. Tout reste modifiable ensuite.": "Three quick questions to tailor your Copilot. Everything can be changed later.",
  "Vous êtes…": "You are…",
  "Secteur d'activité": "Industry",
  "Choisir…": "Choose…",
  "Nom de votre structure (facultatif)": "Your business name (optional)",
  "Vos priorités du moment": "Your current priorities",
  "Jusqu'à cinq. Le coach s'en servira pour vos plans d'action.": "Up to five. The coach will use them for your action plans.",
  "Autre objectif…": "Other goal…",
  "Ajouter un objectif personnalisé": "Add a custom goal",
  "Prêt à décoller": "Ready for take-off",
  "Vos jours de travail servent à proposer des créneaux réalistes.": "Your working days are used to suggest realistic time slots.",
  "Jours travaillés": "Working days",
  "Votre premier plan d'action sur 30 jours": "Your first 30-day action plan",
  "Trois priorités justifiées et un découpage par semaine, préparés par le coach à partir de vos réponses.": "Three justified priorities and a week-by-week breakdown, prepared by the coach from your answers.",
  "Continuer": "Continue",
  "Générer mon plan": "Generate my plan",
  "Canaux": "Channels",
  "Dans l'application": "In the app",
  "Centre de notifications et pastille.": "Notification centre and badge.",
  "Par e-mail": "By email",
  "Récapitulatif des rappels dus, envoyé par lots.": "Summary of due reminders, sent in batches.",
  "L'envoi d'e-mails n'est pas configuré sur ce serveur.": "Email sending is not configured on this server.",
  "Types de notifications": "Notification types",
  "Rappels de tâches et d'agenda": "Task and calendar reminders",
  "Échéances sous 24 h, retards, rappels d'événements.": "Due within 24 h, overdue items, event reminders.",
  "Rappels de tâches": "Task reminders",
  "Alertes financières": "Financial alerts",
  "Factures à échéance ou en retard.": "Invoices due or overdue.",
  "Invitation le vendredi à générer la Weekly Growth Review.": "A Friday prompt to generate the Weekly Growth Review.",
  "Les rappels sont calculés côté serveur toutes les 15 minutes (et à l'ouverture de l'application), même navigateur fermé.": "Reminders are computed on the server every 15 minutes (and when the app opens), even with the browser closed.",
  "Sur cet appareil": "On this device",
  "Notifications push non disponibles ici : vous recevez vos rappels dans l'application et par e-mail.": "Push notifications aren't available here: you get your reminders in the app and by email.",
  "Notifications push : rappels et alertes, même application fermée.": "Push notifications: reminders and alerts, even when the app is closed.",
  "Notification de test envoyée.": "Test notification sent.",
  "Aucun appareil joignable.": "No reachable device.",
  "Notifications refusées dans les réglages du navigateur.": "Notifications blocked in the browser settings.",
  "Notifications push indisponibles sur ce serveur ou cet appareil.": "Push notifications unavailable on this server or device.",
  "Appareil inconnu": "Unknown device",
  "Navigateur": "Browser",
  "Impossible de charger les sessions.": "Unable to load sessions.",
  "Révocation impossible.": "Unable to revoke.",
  "Session révoquée.": "Session revoked.",
  "Toutes les autres sessions ont été déconnectées.": "All other sessions have been signed out.",
  "Mot de passe actuel incorrect.": "Current password is incorrect.",
  "Mot de passe modifié. Les autres sessions ont été déconnectées.": "Password changed. Other sessions have been signed out.",
  "Mot de passe actuel": "Current password",
  "Modifier le mot de passe": "Change password",
  "Sessions actives": "Active sessions",
  "Appareils actuellement connectés à votre compte. Révoquez toute session que vous ne reconnaissez pas.": "Devices currently signed in to your account. Revoke any session you don't recognise.",
  "Cet appareil": "This device",
  "IP inconnue": "Unknown IP",
  "· active": "· active",
  "Déconnecter toutes les autres sessions": "Sign out all other sessions",
  "Informations personnelles": "Personal information",
  "Vérifiée": "Verified",
  "Envoi impossible pour le moment.": "Unable to send right now.",
  "E-mail de vérification envoyé.": "Verification email sent.",
  "Non vérifiée — renvoyer le lien": "Not verified — resend the link",
  "Profil": "Profile",
  "Secteur": "Industry",
  "Structure": "Business",
  "Fuseau horaire": "Time zone",
  "Langue": "Language",
  "Devise": "Currency",
  "Profil de travail adaptatif": "Adaptive work profile",
  "Le coach utilise uniquement ce que vous déclarez (objectifs, horaires, préférences). Aucune caractéristique sensible n'est déduite.": "The coach only uses what you state (goals, working hours, preferences). No sensitive characteristic is inferred.",
  "Adapter les suggestions à mon profil": "Tailor suggestions to my profile",
  "Désactivez pour que le coach n'utilise plus votre profil.": "Turn off so the coach no longer uses your profile.",
  "Profil adaptatif": "Adaptive profile",
  "Objectifs :": "Goals:",
  "· Difficultés :": "· Challenges:",
  "Effacer": "Clear",
  "Fournisseurs d'IA": "AI providers",
  "Les appels IA sont exécutés côté serveur. Les clés API sont stockées dans les secrets du serveur et ne sont jamais transmises à l'application.": "AI calls run on the server. API keys are stored in the server secrets and are never sent to the app.",
  "· par défaut": "· default",
  "{0} modèle(s) disponible(s)": "{0} model(s) available",
  "Clé API non configurée sur le serveur": "API key not configured on the server",
  "Erreur": "Error",
  "Indisponible": "Unavailable",
  "Utilisé": "In use",
  "Utiliser": "Use",
  "Modèle": "Model",
  "Par défaut, le modèle recommandé par le serveur est utilisé. Vous pouvez en choisir un autre parmi ceux réellement proposés par le fournisseur.": "By default, the server's recommended model is used. You can choose another from those actually offered by the provider.",
  "Modèle {0}": "Model {0}",
  "Automatique (": "Automatic (",
  "Permissions du coach": "Coach permissions",
  "Vous contrôlez ce que le coach peut consulter et proposer. Les actions ne sont jamais exécutées sans votre validation.": "You control what the coach can see and propose. Actions are never run without your approval.",
  "Consulter mes données": "Read my data",
  "Tâches, agenda et projets (lecture seule), transmis au fournisseur d'IA uniquement pour répondre.": "Tasks, calendar and projects (read-only), sent to the AI provider only to answer.",
  "Proposer des actions": "Propose actions",
  "Créer une tâche, un événement, un projet… à valider d'un clic.": "Create a task, an event, a project… to approve in one click.",
  "Préférences de réponse": "Answer preferences",
  "Les quotas sont appliqués côté serveur et dépendent de votre plan.": "Quotas are enforced on the server and depend on your plan.",
  "messages utilisés aujourd'hui.": "messages used today.",
  "Copier l'exemple": "Copy example",
  "Connectez votre Copilote à Zapier, Make, n8n ou à vos propres outils.": "Connect your Copilot to Zapier, Make, n8n or your own tools.",
  "Clés d'API": "API keys",
  "Automatisez votre activité : créez des tâches, rappels, clients ou transactions depuis Zapier, Make, n8n, un formulaire de votre site…": "Automate your business: create tasks, reminders, customers or transactions from Zapier, Make, n8n, a form on your website…",
  "L'API est incluse dans la formule": "The API is included in the plan",
  "Débloquer": "Unlock",
  "Votre nouvelle clé — copiez-la maintenant, elle ne sera plus affichée :": "Your new key — copy it now, it won't be shown again:",
  "Gardez-la secrète, comme un mot de passe. En cas de fuite, révoquez-la.": "Keep it secret, like a password. If it leaks, revoke it.",
  "Nom de la clé": "Key name",
  "Ex. : Zapier, site web": "E.g.: Zapier, website",
  "Lecture seule": "Read-only",
  "Créer une clé": "Create a key",
  "lecture seule": "read-only",
  "· créée": "· created",
  " · utilisée {0}": " · used {0}",
  " · jamais utilisée": " · never used",
  "Révoquer la clé {0}": "Revoke key {0}",
  "Révoquer la clé « {0} » ? Les outils qui l'utilisent ne fonctionneront plus.": "Revoke the key “{0}”? Tools using it will stop working.",
  "Clé révoquée.": "Key revoked.",
  "Exemples": "Examples",
  "Adresse de l'API :": "API address:",
  ". Toutes les requêtes portent l'en-tête": ". Every request carries the header",
  "curl -X POST {0}/tasks \\\n  -H \"Authorization: Bearer {1}\" \\\n  -H \"Content-Type: application/json\" \\\n  -d '{\"title\":\"Rappeler le prospect\",\"priority\":4,\"dueAt\":\"2026-11-03T10:00\"}'": "curl -X POST {0}/tasks \\\n  -H \"Authorization: Bearer {1}\" \\\n  -H \"Content-Type: application/json\" \\\n  -d '{\"title\":\"Call the prospect back\",\"priority\":4,\"dueAt\":\"2026-11-03T10:00\"}'",
  "Programmer un rappel": "Schedule a reminder",
  "curl -X POST {0}/reminders \\\n  -H \"Authorization: Bearer {1}\" \\\n  -H \"Content-Type: application/json\" \\\n  -d '{\"text\":\"Envoyer la facture\",\"remindAt\":\"2026-11-03T09:00\",\"repeat\":\"none\"}'": "curl -X POST {0}/reminders \\\n  -H \"Authorization: Bearer {1}\" \\\n  -H \"Content-Type: application/json\" \\\n  -d '{\"text\":\"Send the invoice\",\"remindAt\":\"2026-11-03T09:00\",\"repeat\":\"none\"}'",
  "Ajouter un client (ex. depuis le formulaire de votre site)": "Add a customer (e.g. from your website form)",
  "curl -X POST {0}/clients \\\n  -H \"Authorization: Bearer {1}\" \\\n  -H \"Content-Type: application/json\" \\\n  -d '{\"name\":\"Paul Martin\",\"email\":\"paul@exemple.fr\",\"notes\":\"Demande de devis via le site\"}'": "curl -X POST {0}/clients \\\n  -H \"Authorization: Bearer {1}\" \\\n  -H \"Content-Type: application/json\" \\\n  -d '{\"name\":\"Paul Martin\",\"email\":\"paul@example.com\",\"notes\":\"Quote request via the website\"}'",
  "Lire les tâches du jour": "Read today's tasks",
  "Avec Zapier ou Make": "With Zapier or Make",
  "Ajoutez une étape « Webhooks » (Zapier :": "Add a “Webhooks” step (Zapier:",
  "; Make :": "; Make:",
  "), méthode POST, l'adresse ci-dessus suivie de": "), POST method, the address above followed by",
  ", l'en-tête": ", the header",
  "et un corps JSON comme dans les exemples. Limite : 120 requêtes par minute et par clé.": "and a JSON body as in the examples. Limit: 120 requests per minute per key.",
  "Pour découvrir votre Copilote.": "To discover your Copilot.",
  "Le petit prix pour bien démarrer.": "The small price to get started.",
  "Pour piloter son activité au quotidien.": "To run your business day to day.",
  "Pour les équipes et les usages intensifs.": "For teams and heavy use.",
  "pour toujours": "forever",
  "par an": "per year",
  "par mois": "per month",
  "Merci ! Votre abonnement sera actif dès la confirmation du paiement (quelques secondes).": "Thank you! Your subscription will be active as soon as the payment is confirmed (a few seconds).",
  "Votre formule": "Your plan",
  "Formule de votre espace personnel.": "Your personal space's plan.",
  "Formule de l'espace « {0} ».": "Plan of the “{0}” space.",
  "Aujourd'hui :": "Today:",
  "requêtes IA": "AI requests",
  " · {0} le {1}": " · {0} on {1}",
  "Paiement en attente : mettez à jour votre moyen de paiement.": "Payment pending: update your payment method.",
  "Essai gratuit": "Free trial",
  "Factures et moyen de paiement": "Invoices and payment method",
  "Les abonnements ne sont pas gérés dans cette application.": "Subscriptions are not managed in this app.",
  "Votre formule actuelle et ses avantages s'appliquent automatiquement sur tous vos appareils.": "Your current plan and its benefits apply automatically on all your devices.",
  "Le paiement en ligne n'est pas encore activé : les formules sont affichées à titre indicatif.": "Online payment isn't enabled yet: plans are shown for information only.",
  "Paiement sécurisé par Stripe. Sans engagement, résiliable à tout moment.": "Secure payment by Stripe. No commitment, cancel anytime.",
  "jours d'essai gratuit sur toutes les formules payantes.": "day free trial on all paid plans.",
  "Actuelle": "Current",
  "{0} requêtes IA par jour": "{0} AI requests per day",
  "{0} de stockage": "{0} of storage",
  "{0} membres par équipe": "{0} members per team",
  "Bientôt disponible": "Coming soon",
  "Changer via « Factures »": "Change via “Invoices”",
  "Essayer gratuitement": "Try for free",
  "Passer à {0}": "Upgrade to {0}",
  "Ce qui est inclus": "What's included",
  "Tâches, agenda, finances, devis et factures, Coach IA": "Tasks, calendar, finances, quotes and invoices, AI Coach",
  "Seul le propriétaire de l'espace peut gérer l'abonnement.": "Only the space owner can manage the subscription.",
  "Informations enregistrées.": "Information saved.",
  "Identité visuelle": "Brand identity",
  "Votre logo, vos couleurs et le style appliqués automatiquement à tous vos PDF et documents Word.": "Your logo, colours and style applied automatically to all your PDF and Word documents.",
  "Identité de l'entreprise": "Business identity",
  "Ces informations figurent sur vos devis et factures.": "This information appears on your quotes and invoices.",
  "Raison sociale": "Company name",
  "Forme juridique": "Legal form",
  "EI, SASU, SARL…": "Sole trader, Ltd, LLC…",
  "N° TVA intracommunautaire": "EU VAT number",
  "Site web": "Website",
  "RCS / RM": "Trade register",
  "Capital social": "Share capital",
  "TVA et facturation": "VAT and invoicing",
  "Assujetti à la TVA": "VAT registered",
  "Désactivez en cas de franchise en base (mention art. 293 B du CGI ajoutée automatiquement).": "Turn off if you are VAT-exempt (art. 293 B notice added automatically).",
  "Taux de TVA par défaut (%)": "Default VAT rate (%)",
  "Préfixe des factures": "Invoice prefix",
  "{YYYY} = année": "{YYYY} = year",
  "Préfixe des devis": "Quote prefix",
  "Chiffres du compteur": "Counter digits",
  "Délai de paiement (jours)": "Payment terms (days)",
  "Mentions de pénalités de retard": "Late payment penalty notice",
  "Numérotation chronologique et continue, attribuée à la finalisation. Les mentions proposées sont indicatives : vérifiez-les avec votre expert-comptable. La facturation électronique obligatoire se déploie progressivement en France.": "Chronological, continuous numbering, assigned when finalised. The suggested notices are indicative: check them with your accountant. Mandatory e-invoicing is being rolled out gradually in France.",
  "Point de départ du solde calculé et du prévisionnel.": "Starting point for the calculated balance and the forecast.",
  "Solde initial déclaré (€)": "Opening balance (€)",
  "À la date du": "As of",
} as Record<string, string>;
